import { combineReducers } from 'redux';

const defaultUnassignedObis = { docs: [], hasNextPage: false };
const unassignedObis = (state = defaultUnassignedObis, action) => {
  switch (action.type) {
    case 'EPIK_BOX_OBI_CONFIG_UPLOAD_SUCCESS': {
      return {
        ...state,
        obiResp: action.data,
      };
    }
    case 'UNASSIGNED_OBIS_CLEAR':
    case 'UNASSIGNED_FILTER_CHANGE':
    case 'BOX_DETAILS_CLEAR_OBI_SELECT':
    case 'POPULATE_EPI':
      return defaultUnassignedObis;
    case 'UNASSIGNED_OBIS_SUCCESS':
      return {
        ...action.boxes,
        ...{ docs: [...state.docs, ...action.boxes.docs] },
      };
    case 'UNASSIGNED_OBIS_ERROR':
    default:
      return state;
  }
};

const defaultAssignedNumbers = [];
const assignedNumbers = (state = defaultAssignedNumbers, action) => {
  switch (action.type) {
    case 'ASSIGNED_NUMBERS_SUCCESS':
      return action.assignedNumbers;
    default:
      return state;
  }
};

const defaultAssignedCompanyNumbers = [];
const assignedCompanyNumbers = (state = defaultAssignedCompanyNumbers, action) => {
  switch (action.type) {
    case 'ASSIGNED_COMPANY_NUMBERS_SUCCESS':
      return action.assignedNumbers;
    default:
      return state;
  }
};

const defaultPriResBox = '';
const priResBox = (state = defaultPriResBox, action) => {
  switch (action.type) {
    case 'SET_ASSIGNED_NUMBERS_SUCCESS':
      return action.setAssignedNumbers;
    default:
      return state;
  }
};

const defaultSpeedTestInfo = '';
const speedTestInfo = (state = defaultSpeedTestInfo, action) => {
  switch (action.type) {
    case 'SPEED_TEST_INFO_SUCCESS':
      return action.speedTestInfo;
    default:
      return state;
  }
};

export default combineReducers({
  unassignedObis,
  assignedNumbers,
  priResBox,
  speedTestInfo,
  assignedCompanyNumbers,
});
